import { jsxs as L, jsx as C } from "react/jsx-runtime";
const o = ({
  width: r,
  height: i,
  className: t
}) => /* @__PURE__ */ L(
  "svg",
  {
    className: t,
    height: i,
    viewBox: "0 0 12 13",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "g",
        {
          clipPath: "url(#clip0_2739_46031)",
          id: "Layer_1",
          children: /* @__PURE__ */ C(
            "path",
            {
              d: "M7.73926 1.73877C6.51621 1.279 5.03455 1.28402 3.61621 1.63818L3.33301 1.71436C2.62658 1.91453 1.95585 2.2104 1.24512 2.51807C1.50103 2.93517 1.73356 3.36907 1.94727 3.80908L2.1543 4.25146C2.33686 4.65419 2.51518 5.11546 2.69531 5.58057C2.87761 6.05127 3.06395 6.53155 3.26758 6.99268C3.6309 7.81535 4.02304 8.51104 4.4834 8.95459L4.68555 9.12842C5.2101 9.53102 5.9004 9.65975 6.65625 9.59033C7.31683 9.52961 7.98945 9.31999 8.55957 9.05811L8.79785 8.94287L8.7998 8.94189L8.83887 8.9165C8.87082 8.89606 8.91886 8.86512 8.96777 8.83643C9.01329 8.80972 9.08234 8.77152 9.15723 8.74365C9.19438 8.72984 9.25393 8.71 9.3252 8.70264C9.37456 8.69756 9.46199 8.69509 9.56055 8.72803L9.6543 8.77002L9.66211 8.77393V8.7749C9.72447 8.81164 9.76507 8.85307 9.77539 8.86377C9.79317 8.88219 9.80748 8.89945 9.81641 8.91064C9.8345 8.93337 9.85086 8.95693 9.86328 8.9751C9.88908 9.01285 9.91696 9.0576 9.94141 9.09717L10.0527 9.28174L10.0557 9.28564C10.4539 9.95077 10.7425 10.6868 10.9492 11.436L10.9746 11.3882C10.533 9.22422 9.42091 7.36813 7.8125 6.02881L7.47559 5.76123C6.94967 5.36328 6.38115 5.03691 5.78223 4.7124C5.19224 4.39275 4.55739 4.0674 3.95215 3.69092C3.74355 3.56097 3.66032 3.29825 3.75586 3.07178C3.83954 2.87353 4.03868 2.75428 4.24707 2.76709L4.33691 2.78076L5.79883 3.14209L5.82422 3.14893C6.30245 3.29372 6.80747 3.44038 7.30762 3.62061L7.80566 3.81299H7.80664C8.84712 4.24957 9.80949 4.99044 10.5498 5.90674C10.5623 5.66146 10.5491 5.43264 10.502 5.17432L10.459 4.96924C10.0492 3.2184 9.0181 2.21955 7.73926 1.73877Z",
              fill: "currentColor",
              id: "Vector",
              stroke: "currentColor",
              strokeLinejoin: "round"
            }
          )
        }
      ),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_2739_46031", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "white",
          height: "12",
          transform: "matrix(-1 0 0 1 11.5 0.88208)",
          width: "11"
        }
      ) }) })
    ]
  }
);
export {
  o as Content
};
